import { KeywordsPipelineInfoDialogProvider } from "~/contexts/keywords-pipeline-info-dialog-context";
import { ProductNavigationBarContent } from "./product-navigation-bar-content";

export const ProductNavigationBar = () => (
  <KeywordsPipelineInfoDialogProvider>
    <ProductNavigationBarContent />
  </KeywordsPipelineInfoDialogProvider>
);
